import { Component, OnInit } from '@angular/core';

import { NavController, ModalController } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { CancelBookingComponent } from 'src/app/pages/flex/components/cancel-booking/cancel-booking.component';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { JobsService } from 'src/app/shared/services/jobs.service';
import { JobDetail } from 'src/app/shared/models/gql/job-detail.model';
import { AccountService } from 'src/app/shared/services/account.service';

@Component({
  selector: 'app-carer-booked-job',
  templateUrl: './carer.page.html',
  styleUrls: ['./carer.page.scss'],
})
export class CarerBookedJobPage implements OnInit {
  public job: JobDetail;

  constructor(
    public accountService: AccountService,
    public navCtrl: NavController,
    private route: ActivatedRoute,
    private modalController: ModalController,
    private utilityService: UtilityService,
    public jobsService: JobsService,
  ) {}

  ngOnInit() {
    // get job details
    this.getJobDetails();
  }

  async cancelBooking() {
    const modal = await this.modalController.create({
      component: CancelBookingComponent,
      componentProps: {
        userId: this.accountService.userIs('consumer') ? this.job?.workerFields?.match?.user?.id : this.job?.client?.id,
        channelUrl: this.job?.workerFields?.conversation?.sendbirdChannelDetail?.channelUrl,
      },
      showBackdrop: true,
      cssClass: 'fullpage-modal',
    });

    // https://github.com/ionic-team/ionic-framework/issues/26872
    modal.shadowRoot.querySelector('.modal-wrapper').removeAttribute('aria-modal');

    modal.present();
  }

  openCancellationPolicy() {
    this.utilityService.openExternalLink('https://mable.com.au/cancellation-policy/');
  }

  /**
   * Get job details.
   *
   */
  private async getJobDetails() {
    const { paramMap } = this.route.snapshot;
    const jobId = Number(paramMap.get('id'));
    try {
      this.job = await this.jobsService.getPostedJobDetailsById(jobId);
    } catch (error) {
      console.error(error);
    }
  }
}
